import createLendingBundle from './createBundle'
import whitepaper from './whitepaper.it'

export default createLendingBundle(whitepaper)
